






import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import PurchaseOrderResourceList from '@superUI/ResourceList/PurchaseOrderResourceList'
import CsvExportResourceTriggerModal from '@triggers/Utils/CsvExportResourceTriggerModal'

settings =
  name: 'PurchaseOrderList'
  components: { SuperContainerView, PurchaseOrderResourceList, CsvExportResourceTriggerModal }

  resources:
    purchase_orders:
      resourceName: 'purchase_order'
      slug: 'purchase_orders'
      infinityScroll: true

    invoices:
      resourceName: 'invoice'
      slug: 'invoices'
      fetch: false

    remittances:
      resourceName: 'remittance'
      slug: 'remittances'
      fetch: false

  vue:
    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      csvExportResourceTrigger: (payloadOptions) ->
        @$refs.csvExportResourceTrigger.fire(@exportCsvParams('purchase_orders', payloadOptions))

      downloadInvoiceCSV: (po) ->
        @triggerResource 'invoices', 'download_invoice', { invoice_id: @ctxInvoice(po).id }

      downloadRemittanceCSV: (po) ->
        @triggerResource 'remittances', 'download_remittance', { remittance_id: @ctxRemittance(po).id }

export default VueOptions.vue settings
